import React from "react";
import { FileSearch, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const QuickAnalyzeCard = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-primary rounded-2xl p-5 flex flex-col gap-3 justify-between">
      <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
        <FileSearch className="w-5 h-5 text-white" />
      </div>
      <div>
        <p className="text-white font-bold text-lg">Quick Analyze</p>
        <p className="text-white/75 text-sm mt-1 leading-snug">
          Paste a policy URL or text and get an instant risk report.
        </p>
      </div>
      <button
        onClick={() => navigate("/analyze")}
        className="flex items-center gap-2 bg-white text-primary text-sm font-semibold px-4 py-2.5 rounded-lg w-fit hover:bg-white/90 transition-colors"
      >
        Start Analysis <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
};

export default QuickAnalyzeCard;
